import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

export const i18n = i18next.use(initReactI18next);

void i18n.init({
  lng: 'en',
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
  react: {
    useSuspense: false,
  },
});

i18n.services.formatter?.add('lowercase', (value: string) =>
  value.toLowerCase(),
);

i18n.services.formatter?.add(
  'lowercaseWithUppercaseFirstChar',
  (value: string) =>
    value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(),
);
